const ADMIN_TOKEN_KEY   = 'admin_token';
const CLIENTE_TOKEN_KEY = 'cliente_token';

export const getAdminToken    = ()       => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken    = (token)  => localStorage.setItem(ADMIN_TOKEN_KEY, token);
export const clearAdminToken  = ()       => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const getClienteToken   = ()       => localStorage.getItem(CLIENTE_TOKEN_KEY);
export const setClienteToken   = (token)  => localStorage.setItem(CLIENTE_TOKEN_KEY, token);
export const clearClienteToken = ()       => localStorage.removeItem(CLIENTE_TOKEN_KEY);

// Endpoints que devuelven 401 esperados (login) — no disparan auto-logout
const AUTH_ENDPOINTS = ['/api/admin/login', '/api/cliente/login', '/api/cliente/register'];

function isAuthEndpoint(url) {
    return AUTH_ENDPOINTS.some(e => url.includes(e));
}

export async function adminFetch(url, options = {}) {
    const token = getAdminToken();
    const headers = { ...(options.headers || {}) };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(url, { ...options, headers });

    // 401 inesperado → token expirado o revocado — limpiar y volver al login
    if (response.status === 401 && !isAuthEndpoint(url)) {
        clearAdminToken();
        window.location.reload();
        return response;
    }

    return response;
}

export async function clienteFetch(url, options = {}) {
    const token = getClienteToken();
    const headers = { ...(options.headers || {}) };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401 && !isAuthEndpoint(url)) {
        clearClienteToken();
        // No recargamos la página entera para el cliente — el contexto lo maneja
    }

    return response;
}

// ── Renovación automática del token admin ──────────────────────────────
// Se activa cuando el usuario regresa a la pestaña después de 30+ min de inactividad.
// Llama a /api/admin/refresh y actualiza el token en localStorage.

let _lastRefresh = Date.now();
const REFRESH_INTERVAL_MS = 30 * 60 * 1000; // 30 minutos

async function tryRefreshAdminToken(baseURL) {
    const token = getAdminToken();
    if (!token) return;

    try {
        const res = await fetch(`${baseURL}/api/admin/refresh`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}`, 'Accept': 'application/json' },
        });
        if (res.ok) {
            const data = await res.json();
            if (data.token) setAdminToken(data.token);
        } else if (res.status === 401) {
            clearAdminToken();
            window.location.reload();
        }
    } catch {
        // red caída — no hacer nada, el siguiente intento lo reintentará
    }
}

export function initAdminTokenRefresh(baseURL) {
    // Al volver a la pestaña, renovar si pasaron más de 30 min
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible') return;
        const elapsed = Date.now() - _lastRefresh;
        if (elapsed >= REFRESH_INTERVAL_MS) {
            _lastRefresh = Date.now();
            tryRefreshAdminToken(baseURL);
        }
    });

    // Renovación periódica mientras la pestaña está activa
    setInterval(() => {
        if (document.visibilityState === 'visible') {
            _lastRefresh = Date.now();
            tryRefreshAdminToken(baseURL);
        }
    }, REFRESH_INTERVAL_MS);
}
